import { IFetchCustomerContractByIdDTO } from 'modules/customer/domain/dtos';
import { IContractsRepository } from 'modules/customer/domain/repositories';

export class FetchCustomerContractByIdUseCase {
  constructor(private contractsRepository: IContractsRepository) {}

  public async execute({
    customerId,
    contractId,
  }: IFetchCustomerContractByIdDTO) {
    return this.contractsRepository.findById({ customerId, contractId });
  }
}
